import { connect } from 'react-redux';
import PropertyNameView from './PropertyNameView';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { homePurchaseGoalsSelector } from '../../../GoalsCRUDSelector';
import { selectCurrentGoal } from './PropertyNameSelector';
import isHomePurchaseGoalValidSelector from '../../HomePurchaseWorkflowSelector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  goal: selectCurrentGoal(state, ownProps),
  homePurchaseGoals: homePurchaseGoalsSelector(state, ownProps),
  doNotSave: !isHomePurchaseGoalValidSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertyNameView);
